var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fee"},[_vm._v("\n  "+_vm._s(_vm.$t('message.fee_notice', {token: _vm.token, fee: _vm.fee}))+"\n  "),_c('div',{staticClass:"note"},[_vm._v("\n    "+_vm._s(_vm.$t('message.fee_subject_to_change'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }